import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const ProjectCard = ({
  id,
  title,
  description,
  category,
  status,
  image,
}) => {
  const { t } = useTranslation();

  return (
    <motion.div
      whileHover={{ y: -5 }}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3 }}
      className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow h-full flex flex-col"
    >
      {image && (
        <div className="w-full h-48 overflow-hidden bg-gray-200">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <div className="p-6 flex-grow">
        <span className="inline-block px-3 py-1 text-sm font-semibold text-primary-600 bg-primary-100 rounded-full mb-2">
          {category}
        </span>
        <h3 className="text-xl font-bold text-gray-800 mb-2">
          {title}
        </h3>
        <p className="text-gray-600 mb-4 line-clamp-3">
          {description}
        </p>

        <div className="mb-4">
          <span className="inline-block text-sm bg-gray-100 px-3 py-1 rounded">
            {status}
          </span>
        </div>
      </div>

      <div className="p-4 border-t border-gray-100">
        <button className="block w-full text-center bg-primary-600 text-white py-2 px-4 rounded hover:bg-primary-700 transition-colors">
          {t('common.learnMore')}
        </button>
      </div>
    </motion.div>
  );
};

export default ProjectCard;
